import { Charts } from './Charts';
import IgdChartsDataProvider from './contexts/IgdChartsDataContext';

const IgdWrapper = () => {
    return (
        <IgdChartsDataProvider>
            <Charts />
        </IgdChartsDataProvider>
    );
};

export default IgdWrapper;
